module.exports = __webpack_public_path__ + "static/media/a3_parking.6b5e1a98.png";